import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  products: [],
  productDetails: null,
  bulkPreview: [],
  bulkUploaded: [],
};

export const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    setProductList: (state = initialState, { payload }) => {
      return {
        ...state,
        products: payload,
      };
    },

    setProductDetails: (state = initialState, { payload }) => {
      return {
        ...state,
        productDetails: payload,
      };
    },

    addProduct: (state = initialState, { payload }) => {
      return {
        ...state,
        products: [...state.products, payload],
      };
    },

    updateProduct: (state = initialState, { payload }) => {
      return {
        ...state,
        products: state.products.map((product) =>
          product._id === payload._id ? payload : product
        ),
      };
    },

    deleteProduct: (state = initialState, { payload }) => {
      return {
        ...state,
        products: state.products.filter((product) => product._id !== payload),
      };
    },
    previewBulkProduct: (state, { payload }) => {
      state.bulkPreview = payload;
    },

    uploadBulkProduct: (state, { payload }) => {
      state.bulkUploaded = [...state.bulkUploaded, ...payload];
      state.products = [...state.products, ...payload];
    },
  },
});
